import {buildCommonGridActionTypes} from "./commonGridATBuilder";
import {buildCommonEditorActionTypes} from "./commonEditorATBuider";

export const MEMBER_WITH_COUPONS_GRID = buildCommonGridActionTypes('MEMBER_WITH_COUPONS');

export const MEMBER_WITH_COUPONS_EDITOR = buildCommonEditorActionTypes('MEMBER_WITH_COUPONS');